/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_ADDING_PAYMENT_TYPES } from 'state/action-types';

import { createReducer } from 'state/utils';

export const paymentTypeId = createReducer(null, {
    [START_ADDING_PAYMENT_TYPES]: (state, { payload }) => payload.paymentTypeId,
});

export default combineReducers({
    paymentTypeId,
});
